import { CityState, DataHeader, DataSource, HorizontalSpacer, Layout, Location, Panel, SearchPanel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutRecurringOrderList extends Layout {
    citystateStopDestCityId: CityState;
    citystateStopOriginCityId: CityState;
    dataheaderMain: DataHeader;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacerLocation: HorizontalSpacer;
    panelConsigneeLocation: Panel;
    panelOrderListContainer: Panel;
    panelShipperLocation: Panel;
    searchRecurringOrders: SearchPanel;
    sourceRecurringOrdersList: DataSource;
    tableRecurringOrders: Table;
    textboxCustomerId: Textbox;
    textboxDestLocation: Location;
    textboxId: Textbox;
    textboxOrderTypeId: Textbox;
    textboxOriginLocation: Location;
    textboxRevenueCodeId: Textbox;
    textboxStopDestAddress2: Textbox;
    textboxStopDestAddress: Textbox;
    textboxStopDestLocationId: Textbox;
    textboxStopDestLocationName: Textbox;
    textboxStopOriginAddress2: Textbox;
    textboxStopOriginAddress: Textbox;
    textboxStopOriginLocationId: Textbox;
    textboxStopOriginLocationName: Textbox;
}
